// Imports
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/base/Index.vue"),
      children: [
        {
          path: "/",
          name: "Home",
          component: () => import("@/views/home/Home.vue")
        },
        {
          path: "/register",
          name: "Home",
          component: () => import("@/views/home/Home.vue")
        },
        {
          path: "/home-two",
          name: "Home Two",
          component: () => import("@/views/home/HomeTwo.vue")
        },
        {
          path: "/home-three",
          name: "Home Three",
          component: () => import("@/views/home/HomeThree.vue")
        },
        {
          path: "/home-four",
          name: "Home Four",
          component: () => import("@/views/home/HomeFour.vue")
        },
        {
          path: "/components",
          name: "Components",
          component: () => import("@/views/home/Index.vue")
        },
        {
          path: "/sale-page-one",
          name: "SalePageOne",
          component: () => import("@/views/pages/SalePageOne.vue")
        },
        {
          path: "/sale-page-two",
          name: "SalePageTwo",
          component: () => import("@/views/pages/SalePageTwo.vue")
        },
        {
          path: "/all-vendors",
          name: "AllVendors",
          component: () => import("@/views/vendor/AllVendors.vue")
        },
        {
          path: "/vendor-store",
          name: "VendorStore",
          component: () => import("@/views/vendor/VendorStore.vue")
        },
        {
          path: "/search-product",
          name: "SearchProduct",
          component: () => import("@/views/shop/SearchProduct.vue")
        },
        {
          path: "/single-product",
          name: "SingleProduct",
          component: () => import("@/views/shop/SingleProduct.vue")
        },
        {
          path: "/cart",
          name: "Cart",
          component: () => import("@/views/shop/Cart.vue")
        },
        {
          path: "/checkout-alternative",
          name: "CheckoutAlternative",
          component: () => import("@/views/shop/CheckoutAlternative.vue")
        },
        {
          path: "/vendor-order-list",
          name: "VendorOrderList",
          component: () => import("@/views/VendorOrderList.vue")
        },
        {
          path: "/order-list",
          name: "OrderList",
          component: () => import("@/views/Orders/OrderList.vue")
        },
        {
          path: "/order-details",
          name: "OrderDetails",
          component: () => import("@/views/Orders/OrderDetails.vue")
        },
        {
          path: "/list-address",
          name: "ListAddress",
          component: () => import("@/views/address/ListAddress.vue")
        },
        {
          path: "/add-address",
          name: "AddAddress",
          component: () => import("@/views/address/AddAddress.vue")
        },
        {
          path: "/view-profile",
          name: "ViewProfile",
          component: () => import("@/views/profile/ViewProfile.vue")
        },
        {
          path: "/edit-profile",
          name: "EditProfile",
          component: () => import("@/views/profile/EditProfile.vue")
        },
        {
          path: "/all-tickets",
          name: "AllTickets",
          component: () => import("@/views/AllTickets.vue")
        },
        {
          path: "/ticket-details",
          name: "TicketDetails",
          component: () => import("@/views/TicketDetails.vue")
        },
        {
          path: "/wishlist",
          name: "Wishlist",
          component: () => import("@/views/Wishlist.vue")
        },
        {
          path: "/product-list",
          name: "ProductList",
          component: () => import("@/views/ProductList.vue")
        },
        {
          path: "/edit-product",
          name: "EditProduct",
          component: () => import("@/views/EditProduct.vue")
        },
        {
          path: "/profile",
          name: "Profile",
          component: () => import("@/views/Profile.vue")
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: () => import("@/views/Dashboard.vue")
        },
        
        {
          path: "/test",
          name: "Test",
          component: () => import("@/views/test")
        },
        {
          path: "/test-2",
          name: "Test 2",
          component: () => import("@/views/test-2")
        },
        {
          path: "/mobile-categories",
          name: "Mobile Categories with layout",
          component: () => import("@/views/MobileCategories.vue")
        },
        {
          path: "/payment",
          name: "Payment",
          component: () => import("@/views/Payment.vue")
        },
        {
          path: "/deposit",
          name: "Deposit",
          component: () => import("@/views/Deposit.vue")
        },
        {
          path: "/withdraw",
          name: "Withdraw",
          component: () => import("@/views/Withdraw.vue")
        },
        {
          path: "/statement",
          name: "Statement",
          component: () => import("@/views/Statement.vue")
        },
        {
          path: "/menu",
          name: "Menu",
          component: () => import("@/views/Menu.vue")
        },
        {
          path: "/contact",
          name: "Contact",
          component: () => import("@/views/Contact.vue")
        },
        {
          path: "/promotion",
          name: "Promotion",
          component: () => import("@/views/Promotion.vue")
        },
        {
          path: "/change-password",
          name: "ChangePassword",
          component: () => import("@/views/ChangePassword.vue")
        },
        {
          path: "/my-account",
          name: "MyAccount",
          component: () => import("@/views/MyAccount.vue")
        },
        {
          path: "/affliate-overall",
          name: "AffliateOverall",
          component: () => import("@/views/AffliateOverall.vue")
        },
        {
          path: "/commission",
          name: "Commission",
          component: () => import("@/views/Commission.vue")
        },
        {
          path: "/wheel",
          name: "Wheel",
          component: () => import("@/views/Wheel.vue")
        },
        {
          path: "/wheel-spin",
          name: "WheelSpin",
          component: () => import("@/views/WheelSpin.vue")
        },
        {
          path: "/wheel-history",
          name: "WheelHistory",
          component: () => import("@/views/WheelHistory.vue")
        },
        {
          path: "/artical",
          name: "Artical",
          component: () => import("@/views/Artical.vue")
        },
      ]
    },
    {
      path: "/sign-up",
      name: "Sign Up",
      component: () => import("@/views/SignUp.vue")
    },
    {
      path: "/landing",
      name: "Landing",
      component: () => import("@/views/Landing.vue")
    },
    {
      path: "/mobile-categories",
      name: "Mobile Categories",
      component: () => import("@/views/MobileCategories.vue")
    },
    {
      path: "/Play",
      name: "Play Games",
      component: () => import("@/views/Play.vue")
    },
    {
      path: "/account/AuthLINE/Signin",
      name: "Line Authentication",
      component: () => import("@/views/LineAuthen.vue")
    }
  ]
});
router.beforeEach((to, from, next) => {
  
  document.title = `${to.name} - ${process.env.VUE_APP_TITLE}`
  next()
})
export default router;
